module.exports = __webpack_public_path__ + "media/images/service/n_7-7bb1b340182ae2daceede72ad9d01ad3.jpg";